import _Vue from 'vue';
import FontAwesomeIcon from '@/plugins/global-fontawesome';

// A place to keep global components.
export const GlobalComponentsPlugin = {
	install(Vue: typeof _Vue) {
		Vue.component('FontAwesomeIcon', FontAwesomeIcon);
	},
};
